import { useNavigate } from "react-router-dom";
import Button from "../../components/Button";

const toSlug = (str) => {
  return str
    .replace(/Đ/g, "D") // Chuyển Đ → D
    .replace(/đ/g, "d") // Chuyển đ → d
    .normalize("NFD") // Chuẩn hóa Unicode
    .replace(/[\u0300-\u036f]/g, "") // Xóa dấu tiếng Việt
    .toLowerCase()
    .replace(/\s+/g, "-") // Thay khoảng trắng bằng dấu "-"
    .replace(/[^a-z0-9-]/g, ""); // Xóa ký tự đặc biệt
};

const FilterButtons = ({ category, selectedCategory }) => {
  const navigate = useNavigate();

  const handleClick = (cat) => {
    if (cat.id === selectedCategory?.id) return;
    navigate(`?category=${toSlug(cat.name)}`);
  };

  return (
    <div className="grid grid-cols-5 gap-4">
      {category.map((cat) => (
        <Button
          type="button"
          variant={selectedCategory?.name === cat.name ? "primary" : "outline"}
          key={cat.name}
          onClick={() => handleClick(cat)}
          title={cat.name}
        >
          <img
            src="/images/category-image.png"
            alt="category"
            className="w-[54px] h-[32px] flex-shrink-0 hidden"
          />
          <span className="truncate">{cat.name}</span>
        </Button>
      ))}
    </div>
  );
};

export default FilterButtons;
